import { makeDraftClaimLineItemLoader } from '~/utils/routing';

export const { loader, useLoaderData } = makeDraftClaimLineItemLoader(
  ({
    context: {
      draftClaimLineItem,
      crewClaim: { claimType },
    },
  }) => ({ draftClaimLineItem, claimType }),
);

export const shouldRevalidate = () => false;
